import React from 'react';
import { Tooltip } from "antd";

export function tooltipUoM() { return <Tooltip title="Unit of Measurement">UoM</Tooltip> }
export function tooltipQty() { return <Tooltip title="Quantity">Qty</Tooltip> }
export function tooltipQtyPlanned() { return <Tooltip title="Quantity Planned">Qty planned</Tooltip> }
export function tooltipQtyDelivered() { return <Tooltip title="Quantity Delivered">Qty delivered</Tooltip> }